/**
 * PrivacyPage — 개인정보 처리방침 (Issue #447 Phase F)
 *
 * F7 SPA의 정적 법적 문서 페이지. 비로그인 접근 가능.
 * 본문은 최소 골격만 두고 운영 단계에서 실 텍스트로 교체.
 */

import { Page, Navbar, Block, BlockTitle } from 'framework7-react';

export default function PrivacyPage() {
  return (
    <Page name="privacy">
      <Navbar title="개인정보 처리방침" backLink="Back" />

      <Block>
        <p>
          DISTILL은 사용자의 개인정보를 안전하게 보호하기 위해 다음 방침에 따라
          정보를 수집·이용·관리합니다.
        </p>
      </Block>

      <BlockTitle>1. 수집 항목</BlockTitle>
      <Block strong>
        <p>이메일 주소, 인증 식별자(Google/Apple sub), 저장한 URL과 메모, 생성된 요약 데이터.</p>
      </Block>

      <BlockTitle>2. 이용 목적</BlockTitle>
      <Block strong>
        <p>로그인 인증, 콘텐츠 큐레이션, AI 요약·검색 제공, 서비스 운영 통계.</p>
      </Block>

      <BlockTitle>3. 보관 기간</BlockTitle>
      <Block strong>
        <p>회원 탈퇴 시 또는 법정 보관 기간 만료 시까지 보관 후 안전하게 파기합니다.</p>
      </Block>

      <BlockTitle>4. 제3자 제공</BlockTitle>
      <Block strong>
        <p>
          AI 요약을 위해 Google Gemini API에 콘텐츠를 전달하며, 인증을 위해
          Google·Apple OAuth 제공자에 인증 식별자를 전달합니다. 그 외 별도 제3자
          제공은 하지 않습니다.
        </p>
      </Block>

      <BlockTitle>5. 문의</BlockTitle>
      <Block strong>
        <p>개인정보 관련 문의는 운영자에게 연락 주시기 바랍니다.</p>
      </Block>
    </Page>
  );
}
